import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';
import { PlanCard, PlanCardHeader, PlanLoading } from '../../Components';

import styles from './Plan.Styles';

function Plan({
  title,
  subTitle,
  titleTextStyle,
  type,
  serviceType,
  name,
  status,
  renewalDate,
  usersIcon,
  withPercentageView,
  usageData,
  price,
  currency,
  isCurrencyFirst,
  withPrice,
  withPriceVat,
  contractData,
  users,
  unassignedUsers,
  withViewPlanButton,
  withUpgradePlanButton,
  onViewPlanPress,
  onUpgradePlanPress,
  onAddUsagePress,
  toggleAddUsageModal,
  images,
  percentageIndicatorFillColor,
  percentageIndicatorSecondaryColor,
  percentageIndicatorShouldAnimate,
  cardContainerStyle,
  nameTextStyle,
  statusTextStyle,
  renewalDateTextStyle,
  numberOfUsersTextStyle,
  usagePercentageContainerStyle,
  percentageIndicatorContainerStyle,
  contractDataContainerStyle,
  usageValuesTextStyle,
  usageViewContainerStyle,
  containerStyle,
  isLoading,
  withPlanCardHeader,
  withUsers,
  hideProgressBars,
  ...props
}) {

  const renderLoading = () => {
    return (
      <PlanLoading
        withPercentageView={withPercentageView}
        withUsers={withUsers}
        hideProgressBars={hideProgressBars}
      />
    );
  };

  const renderPlanCardHeader = () => {
    return <PlanCardHeader subTitle={subTitle} testKey={SohoFrameworkTestKeys.PlanSectionTitle} />;
  };
  const renderPlanCard = () => {
    return (
      <PlanCard
        type={type}
        serviceType={serviceType}
        name={name}
        status={status}
        renewalDate={renewalDate}
        usersIcon={usersIcon}
        withPercentageView={withPercentageView}
        usageData={usageData}
        price={price}
        currency={currency}
        isCurrencyFirst={isCurrencyFirst}
        withPrice={withPrice}
        withPriceVat={withPriceVat}
        contractData={contractData}
        users={users}
        unassignedUsers={unassignedUsers}
        withViewPlanButton={withViewPlanButton}
        withUpgradePlanButton={withUpgradePlanButton}
        onViewPlanPress={onViewPlanPress}
        onUpgradePlanPress={onUpgradePlanPress}
        onAddUsagePress={onAddUsagePress}
        toggleAddUsageModal={toggleAddUsageModal}
        images={images}
        containerStyle={cardContainerStyle}
        nameTextStyle={nameTextStyle}
        statusTextStyle={statusTextStyle}
        renewalDateTextStyle={renewalDateTextStyle}
        numberOfUsersTextStyle={numberOfUsersTextStyle}
        usagePercentageContainerStyle={usagePercentageContainerStyle}
        percentageIndicatorContainerStyle={percentageIndicatorContainerStyle}
        percentageIndicatorFillColor={percentageIndicatorFillColor}
        percentageIndicatorSecondaryColor={percentageIndicatorSecondaryColor}
        percentageIndicatorShouldAnimate={percentageIndicatorShouldAnimate}
        contractDataContainerStyle={contractDataContainerStyle}
        usageValuesTextStyle={usageValuesTextStyle}
        usageViewContainerStyle={usageViewContainerStyle}
        withUsers={withUsers}
        hideProgressBars={hideProgressBars}
        {...props}
      />
    );
  };

  return (
    <View style={[styles.containerStyle, containerStyle]}>
      {isLoading ? (
        renderLoading()
      ) : (
        <>
          {withPlanCardHeader ? renderPlanCardHeader() : null}
          {renderPlanCard()}
        </>
      )}
    </View>
  );
}

Plan.defaultProps = {
  withPlanCardHeader: true,
  withUsers: true,
  hideProgressBars: false,
};

Plan.propTypes = {
  withPlanCardHeader: PropTypes.bool,
  isLoading: PropTypes.bool,
  type: PropTypes.string,
  serviceType: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  renewalDate: PropTypes.string,
  usersIcon: PropTypes.string,
  withPercentageView: PropTypes.bool,
  usageData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      usageType: PropTypes.string,
      icon: PropTypes.string,
      isUnlimited: PropTypes.bool,
      totalAmount: PropTypes.number,
      totalUnits: PropTypes.string,
      usedAmount: PropTypes.number,
      usedUnits: PropTypes.string,
      valuePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
  isCurrencyFirst: PropTypes.bool,
  withPrice: PropTypes.bool,
  withPriceVat: PropTypes.bool,
  contractData: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      name: PropTypes.string,
      '@type': PropTypes.string,
      '@referredType': PropTypes.string,
    }),
  ),
  unassignedUsers: PropTypes.arrayOf(
    PropTypes.shape({
      '@type': PropTypes.string,
      name: PropTypes.string,
      id: PropTypes.string,
      role: PropTypes.string,
    }),
  ),
  withViewPlanButton: PropTypes.bool,
  withUpgradePlanButton: PropTypes.bool,
  onViewPlanPress: PropTypes.func,
  onUpgradePlanPress: PropTypes.func,
  onAddUsagePress: PropTypes.func,
  percentageIndicatorFillColor: PropTypes.string,
  percentageIndicatorSecondaryColor: PropTypes.string,
  percentageIndicatorShouldAnimate: PropTypes.bool,
  images: PropTypes.object,
  containerStyle: ViewPropTypes.style,
  cardContainerStyle: ViewPropTypes.style,
  titleTextStyle: TextPropTypes.style,
  nameTextStyle: TextPropTypes.style,
  statusTextStyle: TextPropTypes.style,
  renewalDateTextStyle: TextPropTypes.style,
  numberOfUsersTextStyle: TextPropTypes.style,
  usagePercentageContainerStyle: ViewPropTypes.style,
  percentageIndicatorContainerStyle: ViewPropTypes.style,
  contractDataContainerStyle: ViewPropTypes.style,
  usageValuesTextStyle: TextPropTypes.style,
  usageViewContainerStyle: ViewPropTypes.style,
  toggleAddUsageModal: PropTypes.func,
  withUsers: PropTypes.bool,
  hideProgressBars: PropTypes.bool,
};

export default Plan;
